import { render, staticRenderFns } from "./memberDialog.vue?vue&type=template&id=2e640b54&"
import script from "./memberDialog.vue?vue&type=script&lang=js&"
export * from "./memberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports